import moment from "moment";

export const datepickerMixin = {
  methods: {
    dateValidate(dateStr) {
      let valid = dateStr.match(
        /^\d{1,2}[-\/](\d{1,2}|(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))[-\/](\d{4}|\d{2})$/i
      );
      if (valid) {
        const d = moment(dateStr, [
          "DD-MM-YY",
          "DD-MMM-YY",
          "DD-MM-YYYY",
          "DD-MMM-YYYY"
        ]);
        if (d.isValid()) {
          return d;
        }
      }
      return false;
    },
    dateFormatter(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    dateParser(date) {
      return moment(date)
        .tz(moment.tz.guess())
        .format();
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/datepickerMixin.js